(function init() {
  angular.module('app').controller('host.views.debugTools.addHubCommunication.modal', [
    '$uibModalInstance',
    'abp.services.app.debugTool',
    function controller($uibModalInstance, debugToolSvc) {
      const vm = this;
      vm.saving = 0;

      vm.cancel = cancel;
      vm.confirm = confirm;

      vm.communicationId = '';
      vm.serviceRequestQueryId = '';


      function cancel() {
        $uibModalInstance.dismiss();
      }

      function confirm() {
        vm.saving += 1;

        const input = {
          communicationId: vm.communicationId,
          serviceRequestQueryId: vm.serviceRequestQueryId,
        };

        debugToolSvc
          .addHubCommunication(input)
          .success(() => {
            abp.notify.info('Added inputted fields to Hub Communication');
          })
          .finally(() => {
            vm.saving -= 1;
            vm.communicationId = '';
            vm.serviceRequestQueryId = '';
          });
      }
    },
  ]);
})();
